import {useData} from "vike-react/useData";
import {ApiVideo, ApiVideosData} from "#/src/definitions/ApiDefinitions";
import {VideoCard} from "#/src/components/VideoCard";
import {Sort} from "#/src/utils/sort-utils";
import {DataWrapped} from "#/src/definitions/AppDefinitions";

export function LatestVideos() {
  const {data: videosData} = useData() as DataWrapped<ApiVideosData>;

  const latestVideos = Sort.byDate(videosData.latestVideos);
  return <section className="video-page my-9">
    <div className="container-xxl">
      <div className="row">
        <div className="col-xl-12">
          <h2 className="basic-headline mb-6">
            Najnowsze filmy
          </h2>
        </div>
      </div>
      <div className="row mb-3">
        {latestVideos.map((video: ApiVideo) => <div key={video.id} className="col-xl-4 col-sm-6 col-md-4"><VideoCard video={video}/></div>)}
      </div>
    </div>
  </section>
}